import { render, staticRenderFns } from "./NewOrderForm.vue?vue&type=template&id=5dfe33ec"
import script from "./NewOrderForm.vue?vue&type=script&lang=js"
export * from "./NewOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports